import { Component, OnInit } from '@angular/core';
import {UserService} from '../shared/user.service';
import {NavigationService} from '../../shared/services/navigation.service';
import {UserSearchCriteria} from "../../shared/user-search-criteria";

@Component({
  selector: 'app-chep-service-rep-list',
  templateUrl: './chep-service-rep-list.component.html',
  styleUrls: ['./chep-service-rep-list.component.scss']
})
export class ChepServiceRepListComponent implements OnInit {
  filters = new UserSearchCriteria();

  loadPage = (page: number, pageSize: number) => this.userService.searchChepRep(page, pageSize, this.filters);

  constructor(
    private userService: UserService,
    private navigationService: NavigationService
  ) {
  }

  ngOnInit(): void {
  }

  goToCreateChepServiceRep() {
    this.navigationService
      .chepServiceRep()
      .create()
      .go();
  }

  goToEditChepRep(userId: string) {
    this.navigationService
      .chepServiceRep()
      .edit(userId)
      .go();
  }
}
